<template>
  <div id="app">
    <component :is="dynamicComponent" :key="dynamicComponent"></component>
    <modal />
  </div>
</template>

<style lang="scss">
#app {
  font-family: "Libre Franklin", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #00586c;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #00586c;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
<script>
import { Modal } from "./components/modal";
import Layout from "./views/_Layout.vue";
import Start from "./views/Start.vue";
import useractivation from "./views/useractivation.vue";
import { EventBus } from "./eventbus";
import store from "./store";
import { watch, ref } from "vue";
import { Idle } from "./utils/Idle";
import i18n from "./i18n";
import { Dialog } from "quasar";
import { useRoute } from "vue-router";

export default {
  title: "Dagtilbud Personale - IST",
  name: "App",
  data() {
    const route = ref(useRoute());
    const dynamicComponent =
      window.location.href.indexOf("useractivation") > -1 ||
        localStorage.getItem("userActivation") !== null
        ? "useractivation"
        : "Start";
    return {
      authenticated: false,
      dynamicComponent: dynamicComponent,
      idleWatcherInitiated: false,
      idleCount: 0,
      userLoggedOff: false,
      idleDialog: null,
      route
    };
  },
  components: {
    Layout,
    Start,
    useractivation,
    Modal
  },
  created: function () {
    // Remove userActivation from localStorage if it is older than 1 minute, to avoid getting stuck in useractivation mode.
    const userActivationObj = localStorage.getItem("userActivation")
      ? JSON.parse(localStorage.getItem("userActivation"))
      : undefined;
    if (userActivationObj && differenceInMinutes(new Date(), new Date(userActivationObj.date)) > 1) {
      localStorage.removeItem("userActivation");
    }
  },
  // eslint-disable-next-line space-before-function-paren
  mounted: async function () {
    watch(this.route, () => {
      if (this.route.path === "/") {
        if (localStorage.testToken) {
          // TO DO Slettes?
        } else {
          this.dynamicComponent = "Start";
        }
      } else if (this.dynamicComponent === "useractivation") {
        return;
      } else if (store.getters["security/getAuthenticationToken"] !== "") {
        this.dynamicComponent = "Layout";
      }
    });

    this.idleInstance = new Idle({
      // Report every 5 minutes.
      activityReportInSec: 298,
      onReportUserIsActive: () => {
        if (this.dynamicComponent === "Start") {
          return;
        }
        this.idleCount = 0;
        store.dispatch("security/keepAlive");
        EventBus.emit("userIsActive");
      },
      onReportUserIsIdle: () => {
        if (this.dynamicComponent === "Start") {
          return;
        }
        this.idleCount = this.idleCount + 1;
        // Circa 15 minutes: show user idle
        if (this.idleCount === 3) {
          this.idleDialog = Dialog.create({
            title: i18n.global.t("idleModal.inactive").toString(),
            message: i18n.global.t("idleModal.inactivityWarning").toString(),
            color: "primary",
            html: true,
            ok: true // takes i18n value, or String for "OK" button label
          }).onOk(async () => {
            return;
          });
        }
        // Circa 20 minutes: logout user
        if (this.idleCount === 4) {
          this.idleDialog.hide();
          Dialog.create({
            title: i18n.global.t("idleModal.inactivity").toString(),
            message: i18n.global.t("idleModal.loggedOffMessage").toString(),
            color: "primary",
            html: true,
            ok: true // takes i18n value, or String for "OK" button label
          }).onOk(async () => {
            return;
          });

          store.commit("security/logout");
          this.dynamicComponent = "Start";
        }
      }
    });

    let TokenExists = store.getters["security/getAuthenticationToken"] !== "";

    const jsonString = localStorage.getItem("userActivation");
    if (this.dynamicComponent === "useractivation") {
      //do nothing;
    } else if (TokenExists) {
      this.dynamicComponent = "Layout";
    } else if (jsonString) {
      this.dynamicComponent = "useractivation";
    } else {
      this.dynamicComponent = "Start";
    }
    //}
  }
};
</script>
